<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "DefaultMain"
}
</script>

<style scoped>

</style>